import { ThemeProvider } from "../theme";

/**
 * Design system root provider. Wraps theme only — no visual changes to legacy screens.
 */
export function DesignSystemProvider({ children }) {
  return <ThemeProvider defaultMode="light">{children}</ThemeProvider>;
}
